import React, { useState } from "react";
import { Button, Checkbox, LoginWrapper, PageHead } from "shared";
import { Field, Formik, Form } from "formik";
import { ROUTE_ENUM, VALIDATION_ENUM } from "enums";
import * as Yup from "yup";
import { useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import axiosInstance from "axiosConfig";
import "./SocialRegisterPage.scss";

const SocialRegisterPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const state = searchParams.get("state") ?? "";
  const provider = searchParams.get("provider") ?? "";

  const validation = () =>
    Yup.object().shape({
      acceptance: Yup.boolean().oneOf([true], VALIDATION_ENUM.REQUIRED),
      rodo: Yup.boolean().oneOf([true], VALIDATION_ENUM.REQUIRED),
    });

  const initialValues = {
    acceptance: false,
    rodo: false,
  };

  const onSubmit = async () => {
    setIsSubmitting(true);
    try {
      await axiosInstance.post(`/auth/${provider}/confirm`, { state });
      navigate(ROUTE_ENUM.INVESTMENTS);
    } catch {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <PageHead
        title="Akceptacja regulaminu – App Reliance Pro"
        description="Zaakceptuj regulamin i RODO, aby dokończyć rejestrację."
      />
      <LoginWrapper>
        <h1 className="login-wrapper__header">Prawie gotowe!</h1>
        <p className="login-wrapper__subtitle">
          Zaakceptuj regulamin i RODO, aby dokończyć rejestrację.
        </p>
        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
          validationSchema={validation()}
        >
          {({ handleSubmit }) => (
            <Form>
              <Field
                id="acceptance"
                name="acceptance"
                wrapperClassName="login-wrapper__acceptance"
                label={
                  <p>
                    Akceptuję postanowienia
                    <a
                      className="login-wrapper__rodo"
                      href={ROUTE_ENUM.TERMS_OF_SERVICE}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {" "}
                      Regulaminu Aplikacji{" "}
                    </a>
                    oraz potwierdzam zapoznanie się z
                    <a
                      className="login-wrapper__rodo"
                      href={ROUTE_ENUM.PRIVACY_POLICY}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {" "}
                      Polityką Prywatności.
                    </a>
                  </p>
                }
                as={Checkbox}
              />

              <Field
                id="rodo"
                name="rodo"
                wrapperClassName="login-wrapper__rodo"
                label={
                  <p>
                    Akceptuję warunki{" "}
                    <a
                      className="login-wrapper__rodo"
                      href={ROUTE_ENUM.RODO}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Klauzuli RODO
                    </a>
                  </p>
                }
                as={Checkbox}
              />

              <Button
                label="Utwórz konto"
                className="button--black button--rounded login-wrapper__submit button--wide"
                onClick={() => handleSubmit()}
                isLoading={isSubmitting}
              />
              <p
                className="login-wrapper__anchor"
                onClick={() => navigate(ROUTE_ENUM.LOGIN)}
              >
                Masz już konto? <span>Zaloguj się</span>
              </p>
            </Form>
          )}
        </Formik>
      </LoginWrapper>
    </>
  );
};

export default SocialRegisterPage;
